module.exports = __webpack_public_path__ + "img/background-off-white.79e8f04.jpg";